import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";
import { toastDispatch } from "@/assets/composables/toast-dispatch";

export default {
  namespaced: true,
  state: {
    plans: [],
    subscriptions: [],
    paystacklink: null,
    active_subscription: [],
  },
  mutations: {
    SET_PLANS(state, data) {
      state.plans = data;
    },
    SET_SUBSCRIPTIONS(state, data) {
      state.subscriptions = data;
    },
    SET_ACTIVESUBSCRIPTION(state, data) {
      state.active_subscription = data;
    },
    SET_PAYMENTLINK(state, data) {
      state.paystacklink = data;
    },
  },
  actions: {
    async getPlans({ commit }) {
      API.get(ROUTES().plans, apiConfig())
        .then((res) => {
          commit("SET_PLANS", res.data.data);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
    },
    async getSubscriptions({ commit }) {
      API.get(ROUTES().subscriptions, apiConfig())
        .then((res) => {
          commit("SET_SUBSCRIPTIONS", res.data.data);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
    },
    async getActiveSubscription({ commit }) {
      API.get(`${ROUTES().subscriptions}/active`, apiConfig())
        .then((res) => {
          commit("SET_ACTIVESUBSCRIPTION", res.data.data);
        })
        .catch((err) => {
          if (err.response.data.error) {
            toast.error(`${err.response.data.error}`);
          } else {
            toast.error(`${err.response.data.message}`);
          }
        });
    },
    // Make Payment
    async makePayment({ commit }, form) {
      commit("SET_PAYMENTLINK", null);
      let result = await API.post(
        ROUTES().subscriptionpayment,
        { ...form },
        apiConfig()
      )
        .then((res) => {
          toastDispatch(res, "success");
          commit("SET_PAYMENTLINK", res.data.data.link);
        })
        .catch((err) => {
          toastDispatch(err, "error");
        });
      return result;
    },
  },
  getters: {
    plans(state) {
      return state.plans;
    },
    subscriptions(state) {
      return state.subscriptions;
    },
    active_subscription(state) {
      return state.active_subscription;
    },
    paystacklink(state) {
      return state.paystacklink;
    },
  },
};
